module.exports = require("./te.d.ts");